import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
}), 'Notes');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Notes.js
// module id = 5086
// module chunks = 2